import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { getSlugValue } from 'utilities';

// Utitlity
export const FUND_INVESTMENTS_DEFAULT_CURRENCY = 'USD';
export const FUND_INVESTMENTS_SAVE_TITLE = 'Save';
export const FUND_INVESTMENTS_INVALID_CELLS_TITLE
  = 'To proceed, please correct the highlighted errors in the table cells';
export const FUND_INVESTMENTS_EMPTY_CELL = Object.freeze({} as ICell);

// Fund investments
export const FUND_INVESTMENTS_TITLE = 'Fund Investments' as const;
export const FUND_INVESTMENTS_TITLE_SINGULAR = 'Fund Investment';
export const FUND_INVESTMENTS_SLUG = getSlugValue(FUND_INVESTMENTS_TITLE);
export const FUND_INVESTMENTS_FILTER_ID = `filter-${FUND_INVESTMENTS_SLUG}`;
export const FUND_INVESTMENTS_NEW_FUND_INVESTMENT_TITLE = `New ${FUND_INVESTMENTS_TITLE_SINGULAR}`;
export const FUND_INVESTMENTS_NEW_FUND_INVESTMENT_SLUG = getSlugValue(FUND_INVESTMENTS_NEW_FUND_INVESTMENT_TITLE);
export const FUND_INVESTMENTS_CONTAINER_CLASSNAME = `${FUND_INVESTMENTS_SLUG}-container`;

// Companies
export const FUND_INVESTMENTS_COMPANIES_TITLE = 'Companies';
export const FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR = 'Company';
export const FUND_INVESTMENTS_COMPANY_SLUG = getSlugValue(FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR);
export const FUND_INVESTMENTS_COMPANY_FILTER_ID = `filter-${FUND_INVESTMENTS_COMPANY_SLUG}`;
export const FUND_INVESTMENTS_NEW_COMPANY_TITLE = `New ${FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR}`;
export const FUND_INVESTMENTS_FIND_A_COMPANY_PLACEHOLDER = `Find a ${FUND_INVESTMENTS_COMPANIES_TITLE_SINGULAR}`;

// Measurement dates
export const FUND_INVESTMENTS_MEASUREMENT_TITLE = 'measurement date';
export const FUND_INVESTMENTS_NO_MEASUREMENT_DATE_TITLE = `No ${FUND_INVESTMENTS_MEASUREMENT_TITLE} is associated with this ${FUND_INVESTMENTS_TITLE_SINGULAR.toLowerCase()} yet`;
export const FUND_INVESTMENTS_NO_MEASUREMENT_DATE_MESSAGE = `Please add a ${FUND_INVESTMENTS_MEASUREMENT_TITLE} first`;

// Direct investments
export const FUND_INVESTMENTS_DIRECT_INVESTMENTS_TITLE = 'Direct Investments';
export const FUND_INVESTMENTS_DIRECT_INVESTMENT_TITLE = 'Direct Investment';
export const FUND_INVESTMENTS_NEW_DIRECT_INVESTMENT_TITLE = `New ${FUND_INVESTMENTS_DIRECT_INVESTMENT_TITLE}`;
export const FUND_INVESTMENTS_FIND_A_DIRECT_INVESTMENT_PLACEHOLDER = `Find a ${FUND_INVESTMENTS_DIRECT_INVESTMENT_TITLE}`;
